<template>
    <ui-modal name="search-customer">
        <div class="container-search-customer">
            <div class="header">
                <div class="header-title">
                    Buscar Cliente
                </div>

                <div class="header-subtitle">
                    Digite código do cliente ou utilize o leitor do código de barras
                </div>
            </div>

            <div class="body">
                <ui-input
                    v-model="form.data.code"
                    placeholder="Informe o código"
                    :disabled="loader.search"
                    @keyup.enter="searchHandler"
                />
            </div>

            <div class="footer">
                <ui-button
                    :disabled="!form.data.code"
                    :loading="loader.search"
                    design="md primary"
                    @click="searchHandler">
                    Buscar
                </ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'

    import { helpersMixin, utilMixin } from '@/mixins'

    import { mapActions } from 'vuex'
    
    const onScan = require('onscan.js')

    const defaultLoader = () => ({
        search: false
    })

	export default {
		name: 'search-customer-modal',

		components: {
			uiModal,
			uiButton,
            uiInput
		},

        mixins: [helpersMixin, utilMixin],

        data() {
            return {
                form: {
                    data: {
                        code: ''
                    }
                },
                loader: { ...defaultLoader() }
            }
        },

        mounted() {
            // Habilita o evento de scan para todo o DOM
            onScan.attachTo(document, {
                minLength: 11,
                onScan: code => { // Alternativa para document.addEventListener('scan')
                    this.form.data.code = code.match('(?<=DealMain).*')[0]
                    this.searchHandler()
                }
            })
        },

        beforeDestroy() {
            onScan.detachFrom(document)
        },

        methods: {
            ...mapActions('launchDay', ['loadControlDeal']),
            /**
             * Event handler que trata o evento de quando uma busca/seleção de um cliente/negócio
             * é solicitada
             */
            searchHandler: async function () {
                if (!this.$mx_hasValue(this.form.data.code)) return

                try {
                    this.loader.search = true
                    const params = {
                        code: this.form.data.code,
                        type: this.$mx_validateCPF(this.form.data.code) ? 'cpf' : 'cod'
                    }
                    await this.loadControlDeal(params)
                    this.$emit('deal-id', this.form.data.code)
                    this.$root.$emit('modal-close-search-customer')
                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loader.search = false
                }
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>